import { FlowPage } from 'src/lib/flow/FlowPage';
import { isEligibleForLongboardingExperiment } from 'src/lib/flow/pageHelpers';

const isEnabled: FlowPage['isEnabled'] = (context) => {
  return (
    isEligibleForLongboardingExperiment(context) &&
    context.experimentFlags.longboarding == 'treatment'
  );
};

const longboardingAnythingElsePage: FlowPage = {
  slug: () => 'anything-else',
  title: () => 'Anything else you’d like to share about your home?',
  subtitle: () => 'This can be anything else you’d like us to consider as we prepare your offer.',
  isEnabled,
  autoAdvance: () => true,
  showSkipButton: () => true,
  questions: () => [
    {
      key: 'home.anything_else',
      type: 'multi_line_text',
      optional: true,
    },
  ],
};

export default longboardingAnythingElsePage;
